class Index {

    constructor() {
        this.PARENT_STORES_SEARCH_FORM = document.forms['parentStoresSearchForm'];
        this.FORM_SEARCH = this.PARENT_STORES_SEARCH_FORM['search'];
    }

    setUpClickEventListener() {
        this.FORM_SEARCH.addEventListener('click', () => { this.PARENT_STORES_SEARCH_FORM.submit(); });
    }

    Run() {
        this.setUpClickEventListener();
    }

}
export { Index }
